import { Card, CardBody, CardFooter, Input } from "reactstrap";
import { formatNumberWithCommas } from "../../helpers/helpers";
import { statesArray } from "../../data";

const SaleOrderTotalCard = ({
  height,
  totalTaxAmount,
  setTotalTaxAmount,
  subTotal,
  totalAmount,
  discount = true,
  totalTax,
  orderData,
}) => {
  const handleInputChange = (e, field) => {
    let { value } = e.target;

    if (value === "" || isNaN(value)) {
      value = 0;
    }

    setTotalTaxAmount({
      ...totalTaxAmount,
      [field]: parseFloat(value),
    });
  };

  const renderItems = () => {
    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <p className="mb-0">Sub Total</p>
          <Input
            style={{ width: "150px", border: "0px" }}
            readOnly
            value={formatNumberWithCommas(parseFloat(subTotal ?? 0).toFixed(2))}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-1">
          <p className="mb-0">Tax %</p>
          <div className="d-flex gap-2">
            <Input
              style={{ width: "150px", height: "30px" }}
              value={totalTaxAmount?.tax ?? 0}
              disabled={orderData?.taxExemptStates?.some((exState) =>
                statesArray.some(
                  (s) => s.value === exState || s.code === exState
                )
              )}
              type="number"
              min={0}
              onChange={(e) => handleInputChange(e, "tax")}
              onBlur={(e) => {
                if (!e.target.value) e.target.value = 0;
              }}
            />

            <Input
              style={{ width: "150px", height: "30px" }}
              value={totalTax ? parseFloat(totalTax).toFixed(2) : 0}
              type="number"
              readOnly
            />
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-1">
          <p className="mb-0">Shipping</p>
          <Input
            style={{ width: "150px", height: "30px" }}
            value={totalTaxAmount?.shippingAmount ?? 0}
            type="number"
            min={0}
            onChange={(e) => handleInputChange(e, "shippingAmount")}
            onBlur={(e) => {
              if (!e.target.value) e.target.value = 0;
            }}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center mb-1">
          <p className="mb-0">Insurance</p>
          <Input
            style={{ width: "150px", height: "30px" }}
            value={totalTaxAmount?.insurance ?? 0}
            type="number"
            min={0}
            onChange={(e) => handleInputChange(e, "insurance")}
            onBlur={(e) => {
              if (!e.target.value) e.target.value = 0;
            }}
          />
        </div>

        {discount === true && (
          <div className="d-flex justify-content-between align-items-center mb-1">
            <p className="mb-0">Discount</p>
            <Input
              style={{ width: "150px", height: "30px" }}
              value={totalTaxAmount?.discount ?? 0}
              type="number"
              min={0}
              onChange={(e) => handleInputChange(e, "discount")}
              onBlur={(e) => {
                if (!e.target.value) e.target.value = 0;
              }}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <Card
      className="bg-secondary-color border-1 px-0"
      style={{ height: `${height} !important` }}
    >
      <CardBody>{renderItems()}</CardBody>
      <CardFooter>
        <div className="d-flex justify-content-between align-items-center primary-color fw-bold">
          <h5>Total</h5>
          <h5>
            $
            {totalAmount
              ? formatNumberWithCommas(parseFloat(totalAmount).toFixed(2))
              : 0}
          </h5>
        </div>
      </CardFooter>
    </Card>
  );
};

export default SaleOrderTotalCard;
